// src/components/Ouvidoria/OuvidoriaPage.js
import React, { useState } from 'react';
import OuvidoriaUserView from './OuvidoriaUserView';
import OuvidoriaAdminView from './OuvidoriaAdminView';
import OuvidoriaProtocolView from './OuvidoriaProtocolView'; // <<-- NOVO IMPORTE
import '../../styles/Ouvidoria.css';
import { FaTasks, FaPenSquare, FaSearch } from 'react-icons/fa'; // <<-- Ícones para as abas

const OuvidoriaPage = ({ userData }) => {
  // Estado para controlar a visão ativa: 'form', 'dashboard', ou 'protocolo'
  const [activeView, setActiveView] = useState('form');

  if (!userData) {
    return <p>Carregando informações do usuário...</p>;
  }

  const isAdmin = userData.departamento === 'People';

  // Componente para renderizar as abas de alternância
  const ViewToggle = () => (
    <div className="ouvidoria-view-toggle">
      <div className="toggle-button-wrapper">
        <button
          className={`toggle-button ${activeView === 'form' ? 'active' : ''}`}
          onClick={() => setActiveView('form')}
        >
          <FaPenSquare /> Enviar Mensagem
        </button>

        {/* Botão de consulta visível para todos */}
        <button
          className={`toggle-button ${activeView === 'protocolo' ? 'active' : ''}`}
          onClick={() => setActiveView('protocolo')}
        >
          <FaSearch /> Consultar Protocolo
        </button>

        {/* Botão de admin visível apenas para admin */}
        {isAdmin && (
          <button
            className={`toggle-button ${activeView === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveView('dashboard')}
          >
            <FaTasks /> Painel do Gestor
          </button>
        )}
      </div>
    </div>
  );

  const getSubtitle = () => {
      if (activeView === 'dashboard') return "Gerencie manifestações, filtre e analise os dados.";
      if (activeView === 'protocolo') return "Consulte o andamento da sua manifestação de forma segura.";
      return "Um espaço seguro para suas sugestões, elogios ou preocupações.";
  }

  return (
    <div className="ouvidoria-container">
      <div className="ouvidoria-header">
        <h1>Canal de Ouvidoria</h1>
        <p className="ouvidoria-subtitle">{getSubtitle()}</p>
      </div>

      <ViewToggle />

      {/* Lógica de renderização baseada na visão ativa */}
      {activeView === 'form' && <OuvidoriaUserView userData={userData} />}
      {activeView === 'protocolo' && <OuvidoriaProtocolView userData={userData} />}
      {isAdmin && activeView === 'dashboard' && <OuvidoriaAdminView userData={userData} />}

    </div>
  );
};

export default OuvidoriaPage;